import Pusher from "pusher-js";
import React, { createContext, ReactNode,useContext } from "react";

interface PusherProviderProps {
  pusherClient: Pusher;
  children: ReactNode;
}

const PusherContext = createContext<Pusher | null>(null);

export const PusherProvider = ({ pusherClient, children }: PusherProviderProps) => {
  return <PusherContext.Provider value={pusherClient}>{children}</PusherContext.Provider>;
};

export const usePusher = () => {
  const context = useContext(PusherContext);
  if (context === undefined) {
    throw new Error("usePusher must be used within a PusherProvider");
  }
  return context;
};
